<template>
  <v-container grid-list-md>
    <v-layout
      row
      wrap
    >
      <v-flex xs12>
        <h2>{{ heading }}</h2>
        <span class="subheading">
          {{ subheading }}
        </span>
        <v-divider class="my-3" />
      </v-flex>
      <v-flex xs6>
        <member-card :person="userInfo">
          <template v-slot:action>
            <v-btn @click="infoEditDialog = true">
              Edit
            </v-btn>
          </template>
        </member-card>
      </v-flex>
      <v-dialog 
        v-model="infoEditDialog" 
        max-width="850px"
        min-height="400px"
      >
        <member-form :person="userInfo">
          <template v-slot:action="{ person, validate }">
            <v-btn 
              color="default" 
              @click="infoEditDialog = false"
            >
              Close
            </v-btn>
            <v-btn 
              color="primary" 
              @click="save(person, validate)"
            >
              Save
            </v-btn>
          </template>
        </member-form>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import MemberCard from '@/components/member/MemberCard.vue'
import MemberForm from '@/components/member/MemberForm.vue'

export default {
  name: 'Member',
  components: {
    'member-card': MemberCard,
    'member-form': MemberForm
  },
  data() {
    return {
      userInfo: {},
      infoEditDialog: false,
    }
  },
  computed: {
    heading() {
      return 'My Profile'
    },
    subheading() {
      return ''
    },
    ...mapState([
      'user',
    ])
  },
  created() {
    this.$store.dispatch('members/one', this.user.userId)
      .then(data => {
        this.userInfo = data
      })
  },
  methods: {
    save(member, validate) {
      if(!validate()) { return }
      this.$store.dispatch('members/update', member)
        .then(() => {
          this.$store.dispatch('showMessage', { state: 'success', message: 'Your info have been updated' })
          this.userInfo = member
          this.infoEditDialog = false
        })
        .catch(() => this.$store.dispatch('showMessage', { state: 'error', message: 'Something went wrong, we were unable to update your info' }))
    }
  }
}
</script>

<style>

</style>